import { ApiResponseOne } from "./../shared/types/responses";
import {
  CommissionableServiceRequest,
  CommissionableServiceResponse,
  CommissionableServiceFormValues,
} from "../shared/types/commissionable-service.types";
import { CommissionCalculationResponse } from "../shared/types/commission-calculation.type";
import hvpAuthenticatedApi from "../api/hvpAuthenticatedApi";
import dayjs from "dayjs";
import { BaseService } from "./base.service";
import { convertDatesToDayJS, convertDatesToString } from "../shared/helpers";
import { AxiosParams } from "../shared/types";

const API_URL = "/commissionable-services";
export class CommissionableServicesService extends BaseService<
  CommissionableServiceRequest,
  CommissionableServiceResponse,
  CommissionableServiceFormValues
> {
  constructor() {
    super(API_URL);
  }

  public transformResponseToFormValues(
    response: CommissionableServiceResponse
  ): CommissionableServiceFormValues {
    return convertDatesToDayJS(response);
  }

  public transformFormValuesToRequest(
    formValues: CommissionableServiceFormValues
  ): CommissionableServiceRequest {
    return convertDatesToString(formValues);
  }

  public async getCommissionCalculation(
    params?: AxiosParams
  ): Promise<ApiResponseOne<CommissionCalculationResponse>> {
    const response = await hvpAuthenticatedApi.get<
      ApiResponseOne<CommissionCalculationResponse>
    >(`${API_URL}/commission-calculation`, { params });
    return response.data;
  }
}
